﻿import { defineStore } from 'pinia';

export const softoolsSignalrConnectionStateChangedEventName = 'softools:signalr-connection-state-changed';

export interface SoftoolsSignalrConnectionStateChangedEventDetail {
    isConnected: boolean;
}

function dispatchSignalrConnectionStateChanged(isConnected: boolean): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent<SoftoolsSignalrConnectionStateChangedEventDetail>(
        softoolsSignalrConnectionStateChangedEventName,
        {
            detail: {
                isConnected
            }
        }
    ));
}

export const useSoftoolsSignalrStore = defineStore('softoolsSignalrModule', {
    state: () => ({
        // This flag is set when the SignalR connection has been started and
        // can be used for communication.
        // The SignalR connection object itself can be found at window.softools.signalrConnection
        // (see softools-window.ts) to avoid loading a big object into shared state.
        _signalRIsConnected: false
    }),
    getters: {
        signalRIsConnected: state => state._signalRIsConnected
    },
    actions: {
        setSignalRIsConnected(newValue: boolean): void {
            this._signalRIsConnected = newValue;
            dispatchSignalrConnectionStateChanged(newValue);
        }
    }
});

export type SoftoolsSignalrModule = ReturnType<typeof useSoftoolsSignalrStore>;

export default useSoftoolsSignalrStore;
